import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import { URL, APK_UPDATE_RESOURCES } from '../../helper';
import useService from '../../useService';
import { EWebsiteUpdateDashBoardActions } from '../../utils/contsants';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setShowLoader, setForceUpdateRows, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const { requestDeployWebsiteUpdateInfoV2 } = useService();

	switch (action.id) {
		case EWebsiteUpdateDashBoardActions.edit:
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]}/edit`,
					state: {
						rowData
					}
				});
			};
		case EWebsiteUpdateDashBoardActions.clone:
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]}/clone`,
					state: {
						rowData
					}
				});
			};
		case EWebsiteUpdateDashBoardActions.add:
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]}/create`
				});
			};
		case EWebsiteUpdateDashBoardActions.deploy: {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await requestDeployWebsiteUpdateInfoV2(rowData._id);
					showAlert('Bucket activated');
					setForceUpdateRows(true);
				} catch (err: any) {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want to deploy this APK test on website?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
